/**
 * @generated SignedSource<<c5c056459d43ea1438d298f1354986d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useProductIsResizableFetchProductQuery$variables = {
  id: string;
};
export type useProductIsResizableFetchProductQuery$data = {
  readonly model: {
    readonly code: string;
    readonly id: string;
    readonly modelID: number;
    readonly name: string;
    readonly options: ReadonlyArray<{
      readonly colorID: number;
      readonly optionID: number;
      readonly optionsData: {
        readonly isResizable: boolean;
      };
      readonly sideID: number | null;
    }>;
    readonly salesChannelID: string;
    readonly statusID: number;
  } | null;
};
export type useProductIsResizableFetchProductQuery = {
  response: useProductIsResizableFetchProductQuery$data;
  variables: useProductIsResizableFetchProductQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "Model",
    "kind": "LinkedField",
    "name": "model",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "modelID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "statusID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "code",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "salesChannelID",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ModelOption",
        "kind": "LinkedField",
        "name": "options",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "optionID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "colorID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sideID",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ModelOptionsData",
            "kind": "LinkedField",
            "name": "optionsData",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isResizable",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useProductIsResizableFetchProductQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useProductIsResizableFetchProductQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4e8f64a468eef819bbf747c0abb2d0a3",
    "id": null,
    "metadata": {},
    "name": "useProductIsResizableFetchProductQuery",
    "operationKind": "query",
    "text": "query useProductIsResizableFetchProductQuery(\n  $id: ID!\n) {\n  model(id: $id) {\n    id\n    modelID\n    statusID\n    name\n    code\n    salesChannelID\n    options {\n      optionID\n      colorID\n      sideID\n      optionsData {\n        isResizable\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3afb11c38f3bc7cdfb83d24678f615fd";

export default node;
